function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_463",
  "data-name": "Rectangle 463",
  width: 26.111,
  height: 32.053,
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2592",
  "data-name": "Group 2592",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1039",
  "data-name": "Path 1039",
  d: "M51.286,52.584a8.3,8.3,0,1,0-13.2.271A7.576,7.576,0,0,1,39.843,57.8a.913.913,0,0,1-.187.579c-.984.984-1.1,1.531-.5,2.705-.822,1.745-.093,2.963,1.809,2.967.433,0,.588.2.771.529a3.236,3.236,0,0,0,5.612.142,1.2,1.2,0,0,1,1.222-.675,1.789,1.789,0,0,0,1.631-2.63.886.886,0,0,1-.009-.627,1.842,1.842,0,0,0-.514-2.3.889.889,0,0,1-.327-.5,6.379,6.379,0,0,1,.042-1.3,8.827,8.827,0,0,1,1.9-4.1M44.743,64.936A1.85,1.85,0,0,1,43,64.084h3.114a1.53,1.53,0,0,1-1.368.852m3.572-2.194q-3.725,0-7.451,0c-.338,0-.7.011-.718-.454-.022-.512.365-.515.725-.515q1.9,0,3.791,0h3.66c.339,0,.712.012.727.457.016.485-.36.514-.734.514m.01-2.311c-1.242,0-2.484,0-3.726,0s-2.484,0-3.726,0c-.36,0-.747-.018-.725-.524.02-.455.373-.461.717-.461q3.727,0,7.453,0c.38,0,.745.043.732.52-.012.444-.387.465-.723.466m-.242-3.946c-.07.514-.069,1.038-.1,1.612H41.22c-.029-.454-.041-.883-.086-1.31a9.56,9.56,0,0,0-2.042-4.806,6.655,6.655,0,0,1-.726-7.386,6.585,6.585,0,0,1,6.273-3.864,6.965,6.965,0,0,1,5.584,11.052,10.456,10.456,0,0,0-2.14,4.7",
  transform: "translate(-31.543 -34.224)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1040",
  "data-name": "Path 1040",
  d: "M92.707,64.5a5.8,5.8,0,0,1,3.233,1.278c.372.3.644.656.272,1.1-.344.414-.723.255-1.08-.047a4.294,4.294,0,0,0-2.569-1.009c-.5-.03-.9-.151-.839-.738.053-.54.473-.613.984-.588",
  transform: "translate(-79.7 -56.041)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1041",
  "data-name": "Path 1041",
  d: "M128.846,85.351a.74.74,0,1,1-.74-.74.74.74,0,0,1,.74.74",
  transform: "translate(-110.677 -73.524)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1042",
  "data-name": "Path 1042",
  d: "M100.715,0a.611.611,0,0,0-.677.532V3.5a.7.7,0,0,0,1.354,0V.532A.611.611,0,0,0,100.715,0",
  transform: "translate(-86.929)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1043",
  "data-name": "Path 1043",
  d: "M151.029,31.25a.777.777,0,0,0,.431.2.622.622,0,0,0,.068,0,.5.5,0,0,0,.37-.154l2.093-2.285a.616.616,0,0,0-.13-.861.776.776,0,0,0-.431-.2.507.507,0,0,0-.438.151L150.9,30.389a.507.507,0,0,0-.112.45.776.776,0,0,0,.241.411",
  transform: "translate(-131.018 -24.286)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1044",
  "data-name": "Path 1044",
  d: "M175.8,100.615H173.3c-.274,0-.48.291-.48.677s.206.677.48.677H175.8c.274,0,.48-.291.48-.677s-.206-.677-.48-.677",
  transform: "translate(-150.171 -87.431)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1045",
  "data-name": "Path 1045",
  d: "M150.23,155.123a.4.4,0,0,0-.421-.067,1.049,1.049,0,0,0-.6.607.4.4,0,0,0,.069.421l1.506,1.5a.343.343,0,0,0,.249.1.807.807,0,0,0,.538-.27c.276-.278.347-.61.167-.788Z",
  transform: "translate(-129.629 -134.712)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1046",
  "data-name": "Path 1046",
  d: "M25.229,31.3a.5.5,0,0,0,.371.154.589.589,0,0,0,.067,0,.809.809,0,0,0,.672-.615.508.508,0,0,0-.112-.45L24.135,28.1a.506.506,0,0,0-.438-.151.809.809,0,0,0-.672.616.508.508,0,0,0,.112.45Z",
  transform: "translate(-19.997 -24.286)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1047",
  "data-name": "Path 1047",
  d: "M2.985,100.615H.48c-.274,0-.48.291-.48.677s.206.677.48.677H2.985c.274,0,.48-.291.48-.677s-.207-.677-.48-.677",
  transform: "translate(0 -87.431)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1048",
  "data-name": "Path 1048",
  d: "M32.2,155.293c-.277-.278-.608-.351-.787-.172l-1.506,1.5a.4.4,0,0,0-.069.421.976.976,0,0,0,.237.368.807.807,0,0,0,.538.27.344.344,0,0,0,.249-.1l1.506-1.5a.4.4,0,0,0,.07-.421.975.975,0,0,0-.237-.368",
  transform: "translate(-25.906 -134.709)",
  fill: "#fff"
}));

var SvgHowWorks = function SvgHowWorks(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2594",
    "data-name": "Group 2594",
    width: 26.111,
    height: 32.053,
    viewBox: "0 0 26.111 32.053",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHowWorks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/how-works.1ded764f.svg";
export { ForwardRef as ReactComponent };